var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5346 15.8055C17.1838 15.8055 15.9935 16.4662 15.2458 17.4709L8.78184 14.1798C8.88916 13.8161 8.96458 13.4392 8.96458 13.0414C8.96458 12.5019 8.85334 11.989 8.66116 11.5173L15.426 7.4696C16.1789 8.34812 17.2854 8.91797 18.5346 8.91797C20.7962 8.91797 22.636 7.08866 22.636 4.83984C22.636 2.59103 20.7962 0.761719 18.5346 0.761719C16.2729 0.761719 14.4331 2.59103 14.4331 4.83984C14.4331 5.35808 14.5405 5.84968 14.7185 6.30607L7.93352 10.3656C7.18132 9.51319 6.09071 8.96328 4.86315 8.96328C2.60148 8.96328 0.761719 10.7926 0.761719 13.0414C0.761719 15.2902 2.60148 17.1195 4.86315 17.1195C6.23622 17.1195 7.44664 16.4394 8.19146 15.4064L14.6342 18.6868C14.5155 19.0677 14.4331 19.4645 14.4331 19.8836C14.4331 22.1324 16.2729 23.9617 18.5346 23.9617C20.7962 23.9617 22.636 22.1324 22.636 19.8836C22.636 17.6348 20.7962 15.8055 18.5346 15.8055Z",
    fill: "#120078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.cd028bdb47223e0bbe4a7e90385fbaf2.svg";
export { ForwardRef as ReactComponent };